import React from "react";
import "./LegalPage.css";

function PrivacyPolicyPage() {
  return (
    <div className="legal-page">
      <section className="legal-page-hero">
        <span className="legal-page-kicker">JOBFIND24</span>
        <h1>Privacy Policy</h1>
        <p className="legal-page-intro">
          This Privacy Policy explains how JOBFIND24 collects, uses, and protects information when visitors browse job updates, admit cards, results, answer keys, admission notices, and related educational content on this platform.
        </p>
        <p className="legal-page-updated">Last updated: March 9, 2026</p>
      </section>

      <div className="legal-page-grid">
        <section className="legal-page-card">
          <h2>1. Information We Collect</h2>
          <p>
            We may collect information that you submit directly, such as your name, email address, date, gender, place, and comments when you use the contact form or communicate with us through the website.
          </p>
          <p>
            We may also collect limited technical information such as browser type, device details, referral source, and basic usage data to keep the website secure and improve performance.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To respond to questions, feedback, or support requests.</li>
            <li>To maintain and improve the JOBFIND24 website and its features.</li>
            <li>To monitor service quality, detect misuse, and keep the platform secure.</li>
            <li>To review user interest in jobs, results, admit cards, syllabus, and admission-related content.</li>
          </ul>
        </section>

        <section className="legal-page-card">
          <h2>3. Content and Third-Party Links</h2>
          <p>
            JOBFIND24 may provide links to third-party websites, official recruitment portals, exam authorities, and educational resources. We do not control the privacy practices or content of those external websites. Users should review third-party terms and privacy policies before sharing any information there.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>4. Data Security</h2>
          <p>
            We use reasonable measures to protect information stored through the website. However, no online system can guarantee absolute security. Users should avoid submitting sensitive personal, financial, or confidential information unless it is necessary for communication.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>5. Data Sharing</h2>
          <p>
            We do not sell personal information. Information may be used internally for website management, user support, operational review, or legal compliance where required.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>6. Your Choices</h2>
          <p>
            If you want to correct or remove information submitted through the contact form, you can contact the site administrator using the support details available on the website. We will review reasonable requests according to operational and legal requirements.
          </p>
        </section>

        <section className="legal-page-card">
          <h2>7. Updates to This Policy</h2>
          <p>
            This Privacy Policy may be updated when JOBFIND24 changes website features, data practices, or legal requirements. The updated version will be published on this page with the latest revision date.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;